// extracted by mini-css-extract-plugin
export default {"switchTheme":"styles_switchTheme__oDJoU","moon":"styles_moon__zXhzm","sun":"styles_sun__bKWKb","oval":"styles_oval__O4M+P","switchThemeDark":"styles_switchThemeDark__qbI4S"};